<template>
  <layout>
    <page-header :header="$t('general.add_new')" :actions="headerActions">
      <template #default="props">
        <span
          :class="{
            'btn-primary': rideType === props.action.rideType,
            'btn-default': rideType !== props.action.rideType,
          }"
          class="btn"
        >
          {{ props.action.text }}
        </span>
      </template>
    </page-header>
    <div class="content">
      <PriceForm
        :api-interface="api"
        :ride-type="rideType"
        :vehicle-id="null"
        @saved="returnBack"
        @cancel="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import { mapState } from 'vuex'
import PriceForm from './Form.vue'
import PriceZonesApi from './Api'

const base = 'route-pricing'

export default {
  name: 'ZoneToZonePriceCreate',

  components: {
    PriceForm,
  },

  data() {
    return {
      rideType: 'transfer',
      actions: [],
    }
  },

  computed: {
    ...mapState('zones', ['currentDivision']),
    api() {
      const params = { ride_type: this.rideType }
      if (this.currentDivision?.id) {
        params.division_id = this.currentDivision.id
      }
      return new PriceZonesApi(null, params)
    },
    headerActions() {
      return this.actions
    },
  },

  watch: {
    '$settings._loaded'(loaded) {
      if (loaded) {
        this.updateActions()
      }
    },
  },

  created() {
    if (this.$settings._loaded) {
      this.updateActions()
    }
  },

  methods: {
    updateActions() {
      if (this.$settings.one_price_ride_type) {
        this.rideType = 'city_taxi'
        this.actions = []
      } else {
        this.actions = [
          {
            text: this.$t('enums.ride_type.transfer'),
            onClick: this.onActionClick,
            rideType: 'transfer',
          },
          {
            text: this.$t('enums.ride_type.city_taxi'),
            onClick: this.onActionClick,
            rideType: 'city_taxi',
          },
          {
            text: this.$t('enums.ride_type.delivery'),
            onClick: this.onActionClick,
            rideType: 'delivery',
          },
        ]
      }
    },
    returnBack() {
      this.$router.push({ name: base })
    },
    onActionClick(action) {
      this.rideType = action.rideType
    },
  },
}
</script>
